// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import config from 'config';
import classNames from 'classnames';

export class NoFeaturedEvent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideEmptyState: false
        };
    }

    emptyDone() {
        try {
            window.sessionStorage.setItem('showEmptyFeatured', false);
            this.setState({hideEmptyState: true });
        } catch (e) {
            console.log('error', e);
        }
    }
    render() {
        const {t} = this.props;
        const wrapperClass = classNames('featuredEmptyWrapper', {
            hide: this.state.hideEmptyState
        });
        return (
            <div className={wrapperClass}>
                <div className="centerElement featuredTitle">
                    <p>{t('featuredEmpty.title-1')}</p>
                    <p><span className="highlight">{t('featuredEmpty.title-2')}</span>{t('featuredEmpty.title-3')}</p>
                </div>
                <div className="centerElement featuredEmptyState">
                    <img src={`${config.assets.url}/images/catalog/empty_state.png`} alt="" />
                </div>
                <p className="centerElement">{t('featuredEmpty.feature-five')}</p>
                <div className="centerElement featuredEmptyDone">
                    <button className="btn" onClick={this.emptyDone.bind(this)}>{t('featuredEmpty.done')}</button>
                </div>
            </div>
            );
    }
}
NoFeaturedEvent.propTypes = {
    t: PropTypes.func
};
export default connect(
)(translate(['translation'])(NoFeaturedEvent));



// WEBPACK FOOTER //
// ./src/components/SharedComponents/featuredEmpty.js